import { post } from '@/api/general';

export default {
  create: (body) => post('user-stock/create', body),
  delete: (userStockId) => post(`user-stock/${userStockId}/delete`),
};
